import { render, staticRenderFns } from "./AddendaCreateView.vue?vue&type=template&id=435a1c35&scoped=true&"
import script from "./AddendaCreateView.vue?vue&type=script&lang=js&"
export * from "./AddendaCreateView.vue?vue&type=script&lang=js&"
import style0 from "./AddendaCreateView.vue?vue&type=style&index=0&id=435a1c35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a1c35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VDivider,
  VFlex,
  VLayout,
  VRadio,
  VRadioGroup,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
